import gql from 'graphql-tag';

export const UPDATE_SOCIAL_MEDIA = gql`
  mutation UpdateSocialMedia($socialMediaInput: SocialMediaInput!) {
    updateSocialMedia(socialMediaInput: $socialMediaInput) {
      success
    }
  }
`;
